import { Stack } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';
import { handleUnauthorizedResponse } from '../../../api/http';
import PolicyApi from '../../../api/PolicyApi';
import { AuthData } from '../../../context/auth';
import { ErrorData } from '../../../context/ErrorProvider';
import { PolicyData, withPolicyContext } from '../../../context/policy';
import { successToast } from '../../Toast';

interface Props {
	policyData: PolicyData;
	authData: AuthData;
	errorData: ErrorData;
}

// Handles policies(accepted) without quotes enabled
const AcceptedPolicyActions = (props: Props) => {
	const { authData, policyData, errorData } = props;
	const { policy, setLoading } = policyData;

	const onIssue = async () => {
		setLoading(true);

		try {
			await PolicyApi.issuePolicy(
				authData.auth.authorizationToken,
				policy.locator,
			);
			await policyData.loadData(policy.locator);
			successToast('Successfully issued');
		} catch (error) {
			errorData.handleErrorResponse(error, 'Failed to issue');
			if (await handleUnauthorizedResponse(error, authData)) {
				return;
			}
		}
		setLoading(false);
	};

	const buttons = (
		<Stack direction='row' spacing={1}>
			<Button
				key={'issue'}
				color='primary'
				onClick={onIssue}
				variant='contained'
			>
				Issue Policy
			</Button>
		</Stack>
	);

	const hasWritePermissions = authData.hasPermission('policy.issue');
	return hasWritePermissions ? buttons : null;
};

export default withPolicyContext<Props>(AcceptedPolicyActions);
